import React, { Component } from 'react'
import {
  FacebookShareButton,
  LinkedinShareButton,
  TwitterShareButton,
  WhatsappShareButton,
  TelegramShareButton,
  RedditShareButton,
  FacebookShareCount,
  RedditShareCount,
  FacebookIcon,
  TwitterIcon,
  TelegramIcon,
  LinkedinIcon,
  WhatsappIcon,
  RedditIcon,
} from 'react-share'
import config from '../../../config'

class Share extends Component {
  render () {
    const { title, slug, excerpt, mobile } = this.props
    const realPrefix = config.pathPrefix === '/' ? '' : config.pathPrefix
    const url = config.siteUrl + realPrefix + slug

    const iconSize = mobile ? 36 : 36
    const filter = count => (count > 0 ? count : '')

    return (
      <div className='flex justify-center items-center m-8'>
        <RedditShareButton url={url} title={title} className="mr-4 hover:opacity-50">
          <RedditIcon round size={iconSize} />
          <RedditShareCount url={url}>
            {count => <div className='share-count'>{filter(count)}</div>}
          </RedditShareCount>
        </RedditShareButton>
        <TwitterShareButton url={url} title={title} className="mr-4 hover:opacity-50">
          <TwitterIcon round size={iconSize} />
        </TwitterShareButton>
        <WhatsappShareButton url={url} title={title} className="mr-4 hover:opacity-50">
          <WhatsappIcon round size={iconSize} />
        </WhatsappShareButton>
        <FacebookShareButton url={url} quote={excerpt} className="mr-4 hover:opacity-50">
          <FacebookIcon round size={iconSize} />
          <FacebookShareCount url={url}>
            {count => <div className='share-count'>{filter(count)}</div>}
          </FacebookShareCount>
        </FacebookShareButton>
        <LinkedinShareButton
          url={url}
          title={title}
          description={excerpt}
          className="mr-4 hover:opacity-50"
        >
          <LinkedinIcon round size={iconSize} />
        </LinkedinShareButton>
        <TelegramShareButton url={url} className="mr-4 hover:opacity-50">
          <TelegramIcon round size={iconSize} />
        </TelegramShareButton>
      </div>
    )
  }
}

export default Share